import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useState } from "react";
import { defaultQueryOptions } from "./config";
import { setPortalQueryClient } from "./queryClientRegistry";

interface QueryProviderProps {
  children: React.ReactNode;
}

export const QueryProvider = ({ children }: QueryProviderProps) => {
  const [queryClient] = useState(() => {
    const client = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: defaultQueryOptions.staleTime,
          gcTime: 10 * 60 * 1000,
          retry: (failureCount, error: any) => {
            if (error?.response?.status === 401) {
              return false;
            }
            return failureCount < defaultQueryOptions.retry;
          },
          refetchOnWindowFocus: defaultQueryOptions.refetchOnWindowFocus,
          refetchOnMount: false,
          refetchOnReconnect: false,
        },
        mutations: {
          retry: (failureCount, error: any) => {
            if (error?.response?.status === 401) {
              return false;
            }
            return failureCount < Math.min(defaultQueryOptions.retry, 2);
          },
        },
      },
    });
    setPortalQueryClient(client);
    return client;
  });

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};
